var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0946 14.2407C19.0092 12.6209 19.4417 11.3218 19.4417 10.43C19.4417 5.85972 15.7368 2.15479 11.1665 2.15479C6.59623 2.15479 2.8913 5.85972 2.8913 10.43C2.8913 11.3218 3.32374 12.6209 4.23835 14.2407C5.12289 15.8073 6.32868 17.4505 7.57504 18.9695C8.81519 20.481 10.0608 21.8275 10.9991 22.7983C11.0561 22.8573 11.1119 22.9148 11.1665 22.9709C11.2211 22.9148 11.2769 22.8573 11.3339 22.7983C12.2722 21.8275 13.5178 20.481 14.7579 18.9695C16.0043 17.4505 17.2101 15.8073 18.0946 14.2407ZM11.1665 25.7902C11.1665 25.7902 21.4417 16.1048 21.4417 10.43C21.4417 4.75515 16.8413 0.154785 11.1665 0.154785C5.49166 0.154785 0.891296 4.75515 0.891296 10.43C0.891296 16.1048 11.1665 25.7902 11.1665 25.7902Z",
    fill: "#2BA168"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1664 13.0385C12.359 13.0385 13.3258 12.0717 13.3258 10.8791C13.3258 9.68652 12.359 8.71973 11.1664 8.71973C9.97379 8.71973 9.007 9.68652 9.007 10.8791C9.007 12.0717 9.97379 13.0385 11.1664 13.0385ZM11.1664 15.0385C13.4636 15.0385 15.3258 13.1763 15.3258 10.8791C15.3258 8.58195 13.4636 6.71973 11.1664 6.71973C8.86922 6.71973 7.007 8.58195 7.007 10.8791C7.007 13.1763 8.86922 15.0385 11.1664 15.0385Z",
    fill: "#2BA168"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArea);
export default __webpack_public_path__ + "static/media/area.c2596ce6c6799ed4450a898eeac2748c.svg";
export { ForwardRef as ReactComponent };